
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead, LeadType, Task } from '@/types';

@Component
export default class LeadRenameChildDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Array) readonly childTasks: Task[] | null | undefined;

  dialog = false
  loading = false

  childName = 'Lead figlia'
  childType: LeadType = 'installatore-figlia'

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadRenameChildDialog: onValueChange()'); // eslint-disable-line no-console

    if (val === true) {
      this.childName = !this.childTasks
        || 0 in this.childTasks === false
        || 'childName' in this.childTasks[0] === false
        || !this.childTasks[0].childName
        ? 'Lead figlia'
        : this.childTasks[0].childName;
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get childCount() {
    return this.childTasks && 0 in this.childTasks && this.childTasks[0].childCount
      ? this.childTasks[0].childCount : 1;
  }

  async onCancel() {
    console.log('LeadRenameChildDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onRename() {
    console.log('LeadRenameChildDialog: onRename()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('renameChild', {
      childName: this.childName || 'Lead figlia',
      childCount: this.childCount,
    });

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
